import { styled } from '@mui/system';
import { Popover as PopoverMui } from '@mui/material';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Button = styled('button')`
  height: 38px;
  background: ${theme.palette.secondary.main};
  color: white;
  padding: 0;
  border: none;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    margin: 0 10px;
  }
`;

export const Popover = styled(PopoverMui)`
  .MuiPaper-root {
    padding: 0;
  }
`;

export const DropdownContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
`;

export const Menu = styled('div')`
  padding: 8px;
  width: 212px;
`;

export const RegisterBox = styled('div')`
  padding: 16px 0 8px;
  width: 270px;
  font-size: 14px;
  line-height: 125%;
  color: ${theme.palette.secondary.main};

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    color: ${theme.palette.text.dark};
    margin: 8px 16px;
  }

  .message {
    margin: 8px 16px 16px;
  }

  .registerButton {
    width: 100%;

    button {
      width: 100%;
      margin: 0 16px;
    }
  }

  .separator {
    height: 1px;
    background: ${theme.palette.border.light};
    margin: 20px 0 8px;
  }
`;

export const MenuButton = styled('button')`
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  height: 35px;
  padding: 0 14px;
  color: ${theme.palette.text.dark};
  border: none;
  background: white;
  font-size: 14px;
  cursor: pointer;

  &.login {
    margin: 0 16px;
  }

  &:hover {
    color: ${theme.palette.text.focus};
  }

  svg {
    width: 24px;
    height: 24px;
    margin-right: 14px;
    color: ${theme.palette.secondary.main};
  }
`;

export const Plan = styled('div')`
  color: ${theme.palette.secondary.main};
  margin: 16px 22px 0;
  width: 240px;
  font-size: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${theme.palette.border.light};

  .planNameWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .icon {
      width: 34px;
      height: 34px;
      margin-right: 12px;
      background: ${(props) => theme.palette.pricing[props['data-plan-name']]};
      border-radius: 100%;
      color: ${theme.palette.secondary.main};
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 22px;
        height: 22px;
      }
    }

    .planName {
      line-height: 1;
      flex: 1;

      .planLabel {
        font-size: 18px;
        color: ${theme.palette.text.dark};
        font-weight: 700;
      }
    }
  }

  .planFeaturesWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 4px;

    .planFeature {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      line-height: 1;
      min-width: calc(50% - 2px);

      svg {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }
  }

  .limitExeeded {
    color: red !important;
  }

  .info {
    line-height: 1;
    cursor: pointer;
  }
`;
